import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';
import {ValidatonError} from '../resources/GenericResource';


const ProSettingsNotificationsFormModel = t.struct({
    email_me_hired: t.Bool,
    email_chat_replied: t.Bool,
    email_shift_due: t.Bool,
    email_shift_updated: t.Bool
});

class ProFormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;
        return (
            <div className="tab-section">
                <h2 className="tab-section-title">Email me when</h2>

                <label className="form-control form-control-checkbox">
                    {inputs.email_me_hired}
                    <span className="fake-checkbox"></span>
                    <span className="checkbox-description">I get hired</span>
                </label>

                <label className="form-control form-control-checkbox">
                    {inputs.email_chat_replied}
                    <span className="fake-checkbox"></span>
                    <span className="checkbox-description">Someone replies to my message</span>
                </label>

                <label className="form-control form-control-checkbox">
                    {inputs.email_shift_due}
                    <span className="fake-checkbox"></span>
                    <span className="checkbox-description">Shift is due in 24 hours</span>
                </label>

                <label className="form-control form-control-checkbox">
                    {inputs.email_shift_updated}
                    <span className="fake-checkbox"></span>
                    <span className="checkbox-description">Shift information is updated</span>
                </label>
            </div>
        );
    }
}

function makeProLayout(locals) {
    return <ProFormLayout {...locals}/>
}

const ProForm = baseFormFactory(ProSettingsNotificationsFormModel, true, true);

class ProSettingsNotificationsForm extends ProForm {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        const value = props.initialFormData;

        this.state = {
            isValid,
            value
        };
    }

    getOptions() {

        return {
            auto: 'none',

            template: makeProLayout,

            fields: {
                email_me_hired: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                },

                email_chat_replied: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                },

                email_shift_due: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                },

                email_shift_updated: {
                    template: (locals) => {
                        return (
                            <input type="checkbox" checked={locals.value} onChange={evt => locals.onChange(evt.target.checked)} defaultChecked />
                        );
                    }
                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

ProSettingsNotificationsForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func
};


export default ProSettingsNotificationsForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/ProSettingsNotificationsForm.js
 **/